import React, { useRef, useState, useEffect, Fragment } from "react";
import Multiselect from "multiselect-react-dropdown";
import Layout from "components/layout/Layout";
import localization from "assets/localization/localization";
import { BaseUrl } from "context/baseUrl/baseUrl";
import { useHistory } from "react-router-dom";
import {
  checkEmpty,
} from "services/utils/commonFunctions/CommonFunctions";
import FormSection from "components/form/FormSection";
import Images from "assets/images/imageData";
import Loader from "components/loader/loader";
import { trim } from "lodash";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import "./Document.scss";
import MainLayout from "components/mainLayout/MainLayout";
import DocumentBox from "./DocumentBox";
import callWebService, { callTypes } from "services/utils/networks/network";
import Config from "services/config/config";
import ConstVar from "constants/const";
import DropdownFilter from "components/input/dropdown/dropDownFilter";
import CustomModal from "components/modal/modal";

const Document = ({ match }) => {
  const recordsPerPage = [
    { records_id: 10, records_value: 10 },
    { records_id: 20, records_value: 20 },
    { records_id: 30, records_value: 30 },
    { records_id: 50, records_value: 50 },
  ];
  const [smallModal, setSmallModal] = useState({
    hover1: false,
    hover2: false,
    show: false,
  });
  const nameRef = useRef();
  const [activeComponent] = useState();
  const history = useHistory();
  const scrl = useRef(null);
  const [totalDocuments, setTotalDocuments] = useState();
  const [isLoading, setisLoading] = useState(true);
  const [dataList] = useState([]);
  const [pageNos, setPageNo] = useState(1);
  const [perPageRecord, setPerPageRecord] = useState(10);
  const [documentData, setDocumentData] = useState([]);
  const [partnerName] = useState("");
  const [show, setShow] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [editDocument, setEditDocument] = useState(false);
  const [documentDoc, setDocumentDoc] = useState({
    documentDocFormat: [],
  });

  const [docFormatCheckbox] = useState([
    { name: "jpeg", id: "jpeg" },
    { name: "jpg", id: "jpg" },
    { name: "png", id: "png" },
    { name: "pdf", id: "pdf" },
    { name: "mp3", id: "mp3" },
    { name: "mp4", id: "mp4" },
    { name: "webm", id: "webm" },
    { name: "wmv", id: "wmv" },
    { name: "flv", id: "flv" },
    { name: "avi", id: "avi" },
    { name: "tiff", id: "tiff" },
    { name: "xls", id: "xls" },
    { name: "xlxs", id: "xlxs" },
    { name: "doc", id: "doc" },
    { name: "docx", id: "docx" },
    { name: "xps", id: "xps" },
    { name: "eml", id: "eml" },
    { name: "msg", id: "msg" },
    { name: "xlsx", id: "xlsx" },
    { name: "bin", id: "bin" },
  ]);
  const [docTypeCheck, setDocTypeCheck] = useState([]);
  const [addDocumentData, setAddDocumentData] = useState({
    documentName: "",
    documentCode: "",
    documentType: "",
    documentTypeId: "",
  });

  const [editDocumentData, setEditDocumentData] = useState();

  const [errMsg, setErrMsg] = useState({
    documentName: "",
    documentCode: "",
    documentType: "",
    docFormat: "",
    docTypeCheck: "",
  });

  const handleAscendingOrder = () => {};

  const handleDescendingOrder = () => {};

  const nextPage = async () => {
    setPageNo(pageNos + 1);
  };
  const previousPage = async () => {
    setPageNo(pageNos - 1);
  };

  const handleSearch = async () => {
    if (!nameRef.current.value) return;
    setPageNo(1);
    setisLoading(true);
    const data = {
      searchName: trim(nameRef.current.value),
      pageSize: perPageRecord,
    };
    const res = await callWebService(
      callTypes.post,
      data,
      Config.documentList
    );
    if (res?.data?.data?.documentTypes) {
      setDocumentData(res?.data?.data?.documentTypes);
      setTotalDocuments(res?.data?.data?.pagination?.total_rows);
    }
    setisLoading(false);
  };

  const handleRecordsPerPage = async (event) => {
    setPageNo(1);
    setisLoading(true);
    const data = {
      pageNo: 1,
      pageSize: parseInt(event.target.value),
      searchName: trim(nameRef.current.value),
    };
    const res = await callWebService(
      callTypes.post,
      data,
      Config.documentList
    );
    if (res?.data?.data?.documentTypes) {
      setDocumentData(res?.data?.data?.documentTypes);
      setTotalDocuments(res?.data?.data?.pagination?.total_rows);
    }
    setisLoading(false);
  };

  const handleReset = async () => {
    window.location.reload();
  };

  useEffect(() => {
    const getData = async () => {
      setisLoading(true);
      const data = {
        searchName: nameRef.current.value,
        pageNo: pageNos,
        pageSize: perPageRecord,
      };
      const res = await callWebService(
        callTypes.post,
        data,
        Config.documentList
      );
      if (res?.data?.data?.documentTypes) {
        setDocumentData(res?.data?.data?.documentTypes);
        setTotalDocuments(res?.data?.data?.pagination?.total_rows);
      }
      
      setisLoading(false);
    };
    getData();
  }, [pageNos]);

  const renderHeader = () => {
    let headerElement = [
      "S. No.",
      "Name",
      "Code",
      "Type",
      "Doc Format",
      "Action",
    ];

    return headerElement.map((key, index) => {
      if (key === "Applicant Name" || key === "Order Date") {
        return (
          <th>
            {key}
            &nbsp;
            <div>
              <button
                className="btn-sorting"
                type="button"
                onClick={() => handleAscendingOrder()}
              >
                <img src={Images?.stickUpArrow} alt="" />
              </button>
              <button
                className="btn-sorting"
                type="button"
                aria-haspopup="true"
                aria-expanded="false"
                onClick={() => handleDescendingOrder()}
              >
                <img src={Images?.stickDownArrow} alt="" />
              </button>
            </div>
          </th>
        );
      } else {
        return <th key={index}>{key}</th>;
      }
    });
  };
  useEffect(() => {
    (async () => {
      const data = {
        searchName: "",
        pageNo: pageNos,
        pageSize: perPageRecord,
      };
      const res = await callWebService(
        callTypes.post,
        data,
        Config.documentList
      );
      if (res?.data?.data?.documentTypes) {
        setDocumentData(res?.data?.data?.documentTypes);
        setTotalDocuments(res?.data?.data?.pagination?.total_rows);
      }
      setisLoading(false);
    })();
  }, []);

  const handleClose = () => {
    setShow(false);
    setEditDocument(false);
    setAddDocumentData({
      documentName: "",
      documentCode: "",
      documentType: "",
      documentTypeId: "",
    });
    setErrMsg({
      documentName: "",
      documentCode: "",
      documentType: "",
      docFormat: "",
      docTypeCheck: "",
    });
    setDocTypeCheck([]);
  };
  const handleShow = () => setShow(true);

  const documentChange = (e) => {
    const { name, value } = e.target;
    setAddDocumentData((state) => ({ ...state, [name]: value.toString() }));
  };

  const handleSubmit = async () => {
    try {
      if (docTypeCheck == 0) {
        setErrMsg((state) => ({
          ...state,
          docTypeCheck: "Enter document type",
        }));
        return;
      } else {
        setErrMsg((state) => ({ ...state, docTypeCheck: "" }));
      }

      if (addDocumentData.documentName === "") {
        setErrMsg((state) => ({
          ...state,
          documentName: "Enter document name",
        }));
        return;
      } else {
        setErrMsg((state) => ({ ...state, documentName: "" }));
      }
      if (addDocumentData.documentCode === "") {
        setErrMsg((state) => ({
          ...state,
          documentCode: "Enter document code",
        }));
        return;
      } else {
        setErrMsg((state) => ({ ...state, documentCode: "" }));
      }
      if (addDocumentData.documentType === "") {
        setErrMsg((state) => ({
          ...state,
          documentType: "Enter Document type",
        }));
        return;
      } else {
        setErrMsg((state) => ({ ...state, documentType: "" }));
      }

      setErrMsg("");
      setIsSubmit(true);
      const dataArray = [];
      docTypeCheck.forEach((f) => {
        dataArray.push(f.name);
      });
      const dataObj = {
        name: addDocumentData.documentName,
        code: addDocumentData.documentCode,
        type: addDocumentData.documentType,
        doc_format: dataArray,
        documentTypeId: addDocumentData.documentTypeId,
      };

      const res = await callWebService(
        callTypes.post,
        dataObj,
        Config.addDocumentCode
      );
      if (res.data.code === 200 || res.data.code === true) {
        setErrorMsg("");
        setSuccessMsg(res.data.message);
        setDocTypeCheck([]);
        setIsSubmit(false);
        setAddDocumentData({
          documentName: "",
          documentCode: "",
          documentType: "",
          documentTypeId: "",
        });
        setTimeout(() => {
          document.location.reload();
        }, 500);
      } else if ([409, 400].includes(res.data.code)) {
        setIsSubmit(false);
        setErrorMsg(res.data.data[0].message);
      }
    } catch (error) {
      console.log("ERRROR", error);
    }
  };

  //edit document
  const editDocumentDetail = (data) => {
    setShow(true);
    setEditDocument(true);
    setEditDocumentData(data);
    setIsSubmit(false);
    const documentEditObj = {
      documentName: data.name,
      documentCode: data.code,
      documentType: data.type,
      documentTypeId: data.id,
    };
    setAddDocumentData(documentEditObj);
    setDocumentDoc({ documentDocFormat: data.doc_format });
    const dataArray = [];

    data?.doc_format.forEach((f) => {
      let datas = {
        id: f,
        name: f,
      };
      dataArray.push(datas);
    });
    setDocTypeCheck(dataArray);
  };

  const checkValue = (val) => {
    if (documentDoc?.documentDocFormat?.includes(val)) {
      return "checked";
    }
  };
  const inputSearch = () => {
    return (
      <>
        <div style={{ display: "inline-block" }}>
          <input
            type="text"
            className="search-button"
            name="search"
            placeholder="Search Name..."
            ref={nameRef}
          />
          &nbsp;
          <button className="btn btn-primary" onClick={handleSearch}>
            Search
          </button>
          &nbsp;
          <button className="btn btn-warning" onClick={() => handleReset()}>
            Reset
          </button>
        </div>
        <div style={{ float: "right", position: "relative" }}>
          {documentData && documentData.length > 0 ? (
            <b
              className="pagination-value"
              data-hovered={smallModal.hover1}
              style={{ cursor: "pointer" }}
              onMouseLeave={() => {
                setSmallModal({ ...smallModal, hover1: false, hover2: false });
              }}
              onMouseEnter={() => {
                setSmallModal({ ...smallModal, hover1: true, show: true });
              }}
            >
              {pageNos == 1 ? pageNos : (pageNos - 1) * perPageRecord + 1}-
              {pageNos * perPageRecord > totalDocuments
                ? totalDocuments
                : pageNos * perPageRecord}{" "}
              of {totalDocuments}
            </b>
          ) : (
            <span className="pagination-value">0 - 0 of 0</span>
          )}
          &nbsp;
          {smallModal.hover1 && (
            <div
              className="small-modal"
              onMouseEnter={() => {
                setSmallModal({ ...smallModal, hover2: true });
              }}
              onMouseLeave={() => {
                setSmallModal({ ...smallModal, hover2: false, hover1: false });
              }}
            >
              <span
                className="small-modal-option"
                data-disabled={pageNos === 1 && true}
                onClick={() => {
                  setPageNo(1);
                }}
              >
                Newest
              </span>
              <span
                className="small-modal-option"
                data-disabled={
                  totalDocuments <= pageNos * perPageRecord && true
                }
                onClick={() => {
                  setPageNo(Math.ceil(totalDocuments / 10));
                }}
              >
                Oldest
              </span>
            </div>
          )}
          <button
            className="pagination-button"
            onClick={previousPage}
            title="Newer"
            data-disabled={pageNos <= 1}
            disabled={pageNos <= 1}
          >
            {"<"}
          </button>
          &nbsp;
          <button
            className="pagination-button"
            onClick={nextPage}
            title="Older"
            data-disabled={
              totalDocuments <= pageNos * perPageRecord ||
              documentData.length === 0
            }
            disabled={
              totalDocuments <= pageNos * perPageRecord ||
              documentData.length === 0
            }
          >
            {">"}
          </button>
        </div>
        <button
          style={{ float: "right" }}
          className="btn btn-primary mr-2"
          onClick={() => handleShow()}
        >
          Add Document
        </button>
      </>
    );
  };

  const docFormat = (data) => {
    return data?.toString();
  };

  const onSelect = (selectedList, selectedItem) => {
    setDocTypeCheck(selectedList);
  };

  const onRemove = (selectedList, removedItem) => {
    setDocTypeCheck(selectedList);
  };

  return (
    <BaseUrl.Provider value={{ baseUrl: match.url }}>
      <MainLayout activeComponent={activeComponent} match={match}>
        <Layout
          title={localization.documentCodes}
          isLoading={false}
          isGoback={true}
          className={"desktop-view"}
        >
          {inputSearch()}
          <FormSection>
            <div className="panel-card-table" ref={scrl}>
              <table id="employee" className="table table-bordered">
                <thead>
                  <tr>{renderHeader()}</tr>
                </thead>
                <tbody>
                  {documentData &&
                    documentData.map((data, idx) => (
                      <tr key={idx}>
                        <td>
                          {pageNos === 1
                            ? idx + 1
                            : idx + 1 + (pageNos - 1) * perPageRecord}
                        </td>
                        <td>{data.name} </td>
                        <td>{data.code}</td>
                        <td>{data.type}</td>
                        <td>{docFormat(data.doc_format)}</td>
                        <td>
                          <button
                            className="btn btn-success"
                            onClick={() => editDocumentDetail(data)}
                          >
                            Edit
                          </button>
                        </td>
                        {/* <td>{data.doc_sign}</td> */}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div style={{ maxWidth: "150px" }}>
              <DropdownFilter
                optIdKey="records_id"
                optValueKey="records_value"
                optionList={recordsPerPage}
                placeholder="Records Per Page"
                value={perPageRecord}
                onChange={(event) => {
                  setPerPageRecord(parseInt(event.target.value));
                  handleRecordsPerPage(event);
                }}
              />
            </div>
          </FormSection>
          <Loader isLoading={isLoading} />
        </Layout>
        <div className="mobile-view container">
          <h3>{localization.label.myLead}</h3>
          <div className="my-lead-wrap">
            {!checkEmpty(dataList) &&
              dataList.map((data, index) => (
                <DocumentBox data={data} key={index} history={history} />
              ))}
          </div>
        </div>

        <Modal className="dms-modal" show={show} onHide={handleClose}>
          <Modal.Header closeButton style={{ backgroundColor: "#f7fcfd" }}>
            <Modal.Title>
              {editDocument ? "Edit Document" : "Add Document"}
              <br />
              <span
                style={{
                  color: successMsg ? "green" : "red",
                  fontSize: "small",
                }}
              >
                {successMsg ? successMsg : errorMsg}
              </span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ textAlign: "" }}>
            <Col>
              <label className="mt-2">Document Format</label>
              <Multiselect
                options={docFormatCheckbox}
                selectedValues={docTypeCheck}
                onSelect={onSelect}
                onRemove={onRemove}
                displayValue="name"
                showCheckbox="false"
              />
              <span style={{ color: "red" }}>{errMsg.docTypeCheck}</span>
            </Col>
            <Col>
              <label className="mt-2">Document Name</label>
              <input
                type="text"
                name="documentName"
                className="search-button document-search"
                placeholder="Document Name..."
                onChange={(e) => documentChange(e)}
                value={addDocumentData.documentName || ""}
              />
              <br />
              <span style={{ color: "red" }}>{errMsg.documentName}</span>
            </Col>
            <Col>
              <label className="mt-2">Document Code</label>
              <input
                type="text"
                name="documentCode"
                className="search-button document-search"
                placeholder="Document Code..."
                onChange={(e) => documentChange(e)}
                value={addDocumentData.documentCode || ""}
              />
              <br />
              <span style={{ color: "red" }}>{errMsg.documentCode}</span>
            </Col>
            <Col>
              <label className="mt-2">Document Type</label>
              <input
                type="text"
                name="documentType"
                className="search-button document-search"
                placeholder="Document Type..."
                onChange={(e) => documentChange(e)}
                value={addDocumentData.documentType || ""}
              />
              <br />
              <span style={{ color: "red" }}>{errMsg.documentType}</span>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="default" onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSubmit}>
              {isSubmit ? "Loading..." : "Submit"}
            </Button>
          </Modal.Footer>
        </Modal>
      </MainLayout>
    </BaseUrl.Provider>
  );
};

export default Document;
